import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { AuthError, useAuthServices } from '../authServices';
import { AuthLayout } from '../AuthLayout';
import { Icon } from '../../common/Icon';

/** QZ-D28: lands here after Cognito's hosted Google flow redirects back. */
export const GoogleCallbackPage = () => {
  const { t } = useTranslation();
  const { cognito, session } = useAuthServices();
  const navigate = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    // StrictMode mounts effects twice; this callback must run exactly once.
    if (started.current) return;
    started.current = true;

    (async () => {
      try {
        const tokens = await cognito.completeGoogleSignIn(window.location.href);
        await session.start(tokens);
        navigate('/', { replace: true });
      } catch (thrown) {
        setError(
          thrown instanceof AuthError ? t(`auth.error.${thrown.code}`) : t('auth.error.Unknown')
        );
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <AuthLayout>
        <div className="text-center py-3">
          <div className="alert alert-danger text-start">
            <Icon name="circle-exclamation" />
            <div>{error}</div>
          </div>
          <p className="qz-small qz-muted">{t('auth.callback.tryAgain')}</p>
          <Link className="btn btn-primary" to="/signin">
            {t('auth.callback.backToSignIn')}
          </Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <div className="text-center py-4">
        <div className="spinner-border text-primary mb-3" role="status" aria-hidden="true"></div>
        <p className="fw-semibold mb-0">{t('auth.callback.working')}</p>
      </div>
    </AuthLayout>
  );
};

export default GoogleCallbackPage;
